const primary = {
  50: '#F4E4F5',
  100: '#E4BCE6',
  200: '#D38FD6',
  300: '#C161C6',
  400: '#B33BBA',
  500: '#64ffe6',
  600: '#9705A8',
  700: '#09d1b4',
  800: '#72009A',
  900: '#009f84',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff',
};

export default primary;
